import { useUserIdentityState } from '@provider/user-identity';
import { getComponentEntriesQuery } from './api/query.get-component-entries.js';
import { useQueryWithNotifications } from '../notifications/hook.query-with-notifications.js';
import { groupNotificationsByEntryId } from '../notifications/util.group-notifications-by-entry-id.js';

function useComponentEntries(timespan, extraConfig) {
  const user = useUserIdentityState(state => state.user);
  return useQueryWithNotifications({
    ...getComponentEntriesQuery(user, timespan),
    ...extraConfig
  }, mergeComponentEntriesWithNotifications);
}
function mergeComponentEntriesWithNotifications(componentEntries, notifications) {
  const groupedNotifications = groupNotificationsByEntryId(notifications);
  return componentEntries.map(entry => {
    const mappedEntry = {
      key: entry.objectID,
      component: {
        id: entry.componentID,
        entryId: entry.objectID,
        title: entry.title,
        type: entry.componentType,
        typeLabel: entry.componentLabel
      },
      product: entry.product,
      dialogue: {
        id: entry.dialogueID,
        notifications: groupedNotifications.get(entry.objectID)?.filter(it => it.type === "dialog") ?? []
      },
      createdAt: new Date(entry.created * 1000),
      modifiedAt: entry.modified ? new Date(entry.modified * 1000) : undefined,
      status: {
        isShared: entry.shared,
        state: entry.result?.status || "started",
        score: entry.result?.score ? {
          pointsGotten: entry.result.score.pointsGotten,
          pointsPossible: entry.result.score.pointsTotal
        } : undefined
      }
    };
    if ("student" in entry) {
      return {
        ...mappedEntry,
        student: entry.student,
        shareNotifications: groupedNotifications.get(entry.objectID)?.filter(it => it.type === "share.componentEntry")
      };
    }
    return mappedEntry;
  });
}

export { useComponentEntries };
//# sourceMappingURL=hook.component-entries.js.map
